export const DEFAULT_CURRENCY = "EUR";

export const CUSTOMER_CURRENCIES = [
  "EUR",
  "USD",
  "GBP",
  "RON",
  "CHF",
  "PLN",
  "HUF",
  "SEK",
  "NOK",
  "DKK",
];

export const normalizeCurrencyCode = (currency) => {
  const value = String(currency || DEFAULT_CURRENCY).trim().toUpperCase();
  return /^[A-Z]{3}$/.test(value) ? value : DEFAULT_CURRENCY;
};

export const getCurrencySymbol = (locale, currency) => {
  try {
    const parts = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: normalizeCurrencyCode(currency),
      currencyDisplay: "narrowSymbol",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).formatToParts(0);
    return parts.find((part) => part.type === "currency")?.value || normalizeCurrencyCode(currency);
  } catch (error) {
    return normalizeCurrencyCode(currency);
  }
};

export const formatCurrencyAmount = (locale, currency, value, options = {}) => {
  const {
    fallback = "-",
    minimumFractionDigits = 2,
    maximumFractionDigits = 2,
  } = options;
  const num = Number(value);
  if (!Number.isFinite(num)) return fallback;
  try {
    const normalizedCurrency = normalizeCurrencyCode(currency);
    const formatter = new Intl.NumberFormat(locale, {
      style: "currency",
      currency: normalizedCurrency,
      minimumFractionDigits,
      maximumFractionDigits,
    });
    const parts = formatter.formatToParts(num);
    const numberPart = parts
      .filter((part) => part.type !== "currency" && part.type !== "literal")
      .map((part) => part.value)
      .join("");
    const currencyPart = getCurrencySymbol(locale, normalizedCurrency);
    return `${numberPart} ${currencyPart}`;
  } catch (error) {
    return fallback;
  }
};
